<template>
  <div class="modal fade" id="location-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content" id="myModalLabel3">
        <div class="modal-header">
              <h4 class="modal-title">选择地区</h4>
          </div>
        <div class="modal-body">
          <div class="selected-cities">
            <el-tag 
              v-for="c in selectedCities"
              :key="c.id"
              type="danger"
              closable
              @close="cancelSelection(c)"
              style="margin-right:5px;"
              >{{ c.name }}</el-tag>
          </div>
          <!-- Tab panels -->
          <el-tabs tab-position="left" style="height: 442px;" v-model="activeName">
            <el-tab-pane label="热门城市" name="1">
              <el-row :gutter="20">
                <el-col :span="4" style="padding-bottom:20px">
                  <CityTag :city="hotAll" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in hotCities" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="国内(不含港澳台)" name="11">
              <el-row :gutter="20">
                <el-col :span="4" style="padding-bottom:20px">
                  <CityTag :city="domesticAll" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.province" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="港澳台" name="13">
              <el-row :gutter="20">
                <el-col :span="4" style="padding-bottom:20px">
                  <CityTag :city="hkMcTwAll" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in hkMcTw" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="国外" name="12">
              <el-row :gutter="20">
                <el-col :span="4" style="padding-bottom:20px">
                  <CityTag :city="overseaAll" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.oversea" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
              </el-row>
            </el-tab-pane>
              <el-tab-pane label="A B C" name="2">
                <el-row :gutter="20">
                <el-col :span="4" v-for="c in c.A" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.B" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.C" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
              </el-row>
              </el-tab-pane>
              <el-tab-pane label="D E F G" name="3">
                <el-row :gutter="20">
                <el-col :span="4" v-for="c in c.D" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.E" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.F" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.G" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
              </el-row>
              </el-tab-pane>
              <el-tab-pane label="H I" name="4">
                <el-row :gutter="20">
                <el-col :span="4" v-for="c in c.H" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.I" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
              </el-row>
              </el-tab-pane>
              <el-tab-pane label="J K" name="5">
                <el-row :gutter="20">
                <el-col :span="4" v-for="c in c.J" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.K" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
              </el-row>
              </el-tab-pane>
              <el-tab-pane label="L M N" name="6">
                <el-row :gutter="20">
                  <el-col :span="4" v-for="c in c.L" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.M" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.N" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
              </el-row>
              </el-tab-pane>
              <el-tab-pane label="O P Q R" name="7">
                <el-row :gutter="20">
                  <el-col :span="4" v-for="c in c.O" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.P" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.Q" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.R" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
              </el-row>
              </el-tab-pane>
              <el-tab-pane label="S T U" name="8">
                <el-row :gutter="20">
                  <el-col :span="4" v-for="c in c.S" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.T" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.U" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
              </el-row>
              </el-tab-pane>
              <el-tab-pane label="V W X" name="9">
                <el-row :gutter="20">
                  <el-col :span="4" v-for="c in c.V" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.W" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.X" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
              </el-row>
              </el-tab-pane>
              <el-tab-pane label="Y Z" name="10">
                <el-row :gutter="20">
                  <el-col :span="4" v-for="c in c.Y" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
                <el-col :span="4" v-for="c in c.Z" :key="c.id" style="padding-bottom:20px">
                  <CityTag :city="c" :all="selectedCities" @selected-city="citySelected" />
                </el-col>
              </el-row>
              </el-tab-pane>
          </el-tabs>
          <!-- Tab panels -->
        </div>
        <div class="modal-footer">
          <a href="javascript:void(0)" class="btn theme-btn" @click="confirmSelection">确定</a>
                  <a href="javascript:void(0)" class="btn theme-btn-outlined" @click="closeModal">关闭</a>
              </div>
      </div>
    </div>
  </div>  
</template>
<style>
.selected-cities {
  padding-bottom: 15px;
}
/* no selected tags -> drop the spacer so top gap matches the bottom gap */
.selected-cities:empty {
  padding-bottom: 0;
}
.city-tag {
    padding: 3px 25px;
    border-radius: 50px;
    border: 1px solid #eaeff5;
    font-size: 11px;
    display: inline-block;
    text-transform: uppercase;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.el-tabs__item.is-active {
  color: #d81c00 !important;
}
.el-tabs__item:hover {
  color: #d81c00 !important;
}
.el-tabs__active-bar {
  background-color: #d81c00 !important;
}
#location-modal .el-tabs__content {
  padding: 10px 20px;
}
/* tighten left tab spacing and drop scroll-arrow reserve so 12 tabs fill the
   nav without arrows and YZ sits close to the footer */
#location-modal .el-tabs--left .el-tabs__item {
  height: 34px;
  line-height: 34px;
}
#location-modal .el-tabs__nav-prev,
#location-modal .el-tabs__nav-next {
  display: none;
}
#location-modal .el-tabs--left .el-tabs__nav-scroll,
#location-modal .el-tabs--left .el-tabs__nav-wrap {
  overflow: visible;
}
/* flex layout so variable-width tags wrap cleanly instead of overlapping a fixed grid */
#location-modal .el-tabs__content .el-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 0 !important;
}
/* el-row's clearfix ::before/::after become stray flex items that add a leading
   gap before the first tag; remove them */
#location-modal .el-tabs__content .el-row::before,
#location-modal .el-tabs__content .el-row::after {
  display: none;
}
#location-modal .el-tabs__content .el-col {
  width: auto !important;
  max-width: none !important;
  flex: 0 0 auto;
  padding: 0 !important;
  float: none !important;
}
</style>
<script>
//import QRCode from '@/components/QRCode.vue'
import vPinyin from '@/components/common/vue-py.js'
import CityTag from '@/components/common/CityTag.vue'

export default {
  name: 'LocationModal',
  components: {
    CityTag
  },
  props: ['locations', 'values'],
  data: () => ({
    data: [],
    c: {
     'A': [],
     'B': [],
     'C': [],
     'D': [],
     'E': [],
     'F': [],
     'G': [],
     'H': [],
     'I': [],
     'J': [],
     'K': [],
     'L': [],
     'M': [],
     'N': [],
     'O': [],
     'P': [],
     'Q': [],
     'R': [],
     'S': [],
     'T': [],
     'U': [],
     'V': [],
     'W': [],
     'X': [],
     'Y': [],
     'Z': [],
     'province': [],
     'oversea': []
    },
    activeName: '1',
    selectedCities: []
  }),
  computed: {
    // 全选 tags: hot cities resolve to all hot ids, 国内 to country China (id 1),
    // 国外 to the special 'overseas' marker handled when building the search query
    hotAll: function() {
      return { id: this.hotCities.map(function(c) { return c.id }).join(','), name: '全部热门' }
    },
    domesticAll: function() {
      // 国内 = 中国大陆(港澳台单列)
      return { id: 1, name: '全部国内' }
    },
    hkMcTwAll: function() {
      return { id: '369,370,371', name: '全部港澳台' }
    },
    overseaAll: function() {
      return { id: 'overseas', name: '全部国外' }
    }
  },
  mounted: function() {
    
  },
  watch: {
    // meta.active_locations loads async; rebuild once it arrives so 国外 is populated
    locations: function() {
      this.loadData()
    }
  },
  methods: {
    confirmSelection: function() {
      if (this.selectedCities.length > 0)
        this.$emit('selected', this.selectedCities)
      this.closeModal()
    },
    citySelected: function(c) {
      //console.log(c.id)
      let k = JSON.stringify(this.selectedCities).indexOf(JSON.stringify(c))
      if(k == -1){
        this.selectedCities.push(c)
    } else {
      for (let i = 0; i < this.selectedCities.length; i ++) {
        if (this.selectedCities[i].id == c.id)
          this.selectedCities.splice(i, 1)
      }
      }
    },
    cancelSelection: function(c) {
      for (let i = 0; i < this.selectedCities.length; i ++) {
    if (this.selectedCities[i].id == c.id) {
      this.selectedCities.splice(i, 1)
    }
      }
    },
    closeModal: function() {
      this.$nextTick (function () {
      $('#location-modal').modal('hide')
    })
    },
    inMeta: function(id) {
      return this.locations.some(item=>{
    if(item.id == id){
       return true 
    }
    })
    },
    loadData: function() {
        let that = this,
            query = '/api/location/tree' + (this.$i18n.locale === 'zh' ? '/cn' : '') + '?_=' + Date.parse(new Date())

    this.$http.get(this.API_PREFIX + query).then(function (response) {
      that.data = response.data

      // reset inside the callback so loadData is idempotent even with
      // overlapping calls (created + the meta.active_locations watcher)
      Object.keys(that.c).forEach(k => { that.c[k] = [] })
      that.selectedCities = []
      that.c.S.push({'id': 2, 'name': '上海'})
      that.c.B.push({'id': 11, 'name': '北京'})
      that.c.C.push({'id': 28, 'name': '重庆'})
      that.c.T.push({'id': 28, 'name': '天津'})

      that.data.forEach(function(v) {
        // get oversea: show the country (country level only) if the country itself
        // or any of its cities has jobs (inMeta)
        if (v.id != 1 && v.id != 369 && v.id != 370 && v.id != 371) {
          let hit = that.inMeta(v.id)
          if (!hit && v.child != null && v.child != undefined) {
            for (let i = 0; i < v.child.length && !hit; i ++) {
              let p = v.child[i]
              if (that.inMeta(p.id)) { hit = true; break }
              if (p.child != null && p.child != undefined) {
                for (let j = 0; j < p.child.length; j ++) {
                  if (that.inMeta(p.child[j].id)) { hit = true; break }
                }
              }
            }
          }
          if (hit) {
            that.c.oversea.push({'id': v.id, 'name': v.name})
            if (that.values.indexOf(v.id.toString()) != -1) {
              that.selectedCities.push({'id': v.id, 'name': v.name})
            }
          }
        }
        // only China (id 1) feeds 国内 provinces and A-Z city tabs;
        // 港澳台 come from the static hkMcTw list in the template
        if (v.id == 1 && v.child != null && v.child != undefined) {
          for (let i = 0; i < v.child.length; i ++) {
            that.c.province.push({'id': v.child[i].id, 'name': v.child[i].name})
            //console.log(that.values)
            //console.log(v.child[i].id + ':' + that.values.indexOf(v.child[i].id.toString()))
            if (that.values.indexOf(v.child[i].id.toString()) != -1) {
                  that.selectedCities.push({'id': v.child[i].id, 'name': v.child[i].name})
            }
            //console.log(v.child[i])

            let p = v.child[i]
            //console.log(p.id)
            if (p.child != null && p.child != undefined && p.id != 2 && p.id != 11 && p.id != 21 && p.id !=28) {
              for (let j = 0; j < p.child.length; j ++) {
                //console.log(p.child[j])
                if (p.child[j].type == 2) {
               let py = vPinyin.chineseToPinYin(p.child[j].name).charAt(0)
               //console.log(py)
               if (that.values.indexOf(p.child[j].id.toString()) != -1) {
                         that.selectedCities.push({'id': p.child[j].id, 'name': p.child[j].name})
                   }
               eval('that.c.' + py + '.push({\'id\': ' + p.child[j].id + ', \'name\': \'' + p.child[j].name + '\'})')
            }
              }
            }
          }
        }
      })
      /*that.meta.active_locations.sort(function(a, b) {
          return a.c_fullname.localeCompare(b.c_fullname, 'zh')
        })*/
      //console.log(that.c)
    }).catch(function (error) {
      console.log(error)
    })
    }
  },
  created: function() {
    /*this.locations.forEach(function(v) {
      let py = vPinyin.chineseToPinYin(v.c_name)
    })*/
    /*console.log(this.values)
    if (this.values != null && this.values.length > 0) {
      for (let i = 0; i < this.values.length; i ++) {
        this.selectedCities.push({'id': this.values[i], 'name': ''})
      }
    }*/
      
    this.loadData()
  }
}
</script>
